var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "video-view",
        { attrs: { "has-fullscreen": false, variant: "is-blue" } },
        [
          _c("template", { slot: "title-first" }, [
            _c("div", [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("header_5_1")) + "\n\n        "
              ),
              _c("div", { staticClass: "underline" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("header_5_2")) + "\n        "
                )
              ]),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("header_5_3")) + "\n        "
              ),
              _c("div", { staticClass: "underline" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("header_5_4")) + "\n        "
                )
              ])
            ])
          ]),
          _c(
            "video",
            {
              attrs: { autoplay: "", muted: "", loop: "", playsinline: "" },
              domProps: { muted: true }
            },
            [
              _c("source", {
                attrs: {
                  type: "video/mp4",
                  src:
                    "https://media.blissapplications.com/videos/desktop-1440-clip-about-us.mp4"
                }
              })
            ]
          )
        ],
        2
      ),
      _c(
        "about-view",
        {
          directives: [
            {
              name: "inview",
              rawName: "v-inview:class",
              value: ["animate"],
              expression: "['animate']",
              arg: "class"
            }
          ]
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _c(
              "div",
              {
                staticClass: "underline underline--no-delay underline--primary"
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("about_1_1")) + "\n      ")]
            ),
            _c(
              "div",
              {
                staticClass:
                  "on-tablet underline underline--no-delay\n      underline--primary"
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("about_1_4")) + "\n      ")]
            ),
            _c(
              "div",
              {
                staticClass: "underline underline--no-delay underline--primary"
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("about_1_2")) + "\n      ")]
            ),
            _c(
              "div",
              {
                staticClass:
                  "on-tablet underline underline--no-delay\n      underline--primary"
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("about_1_4")) + "\n      ")]
            ),
            _c(
              "div",
              {
                staticClass: "underline underline--no-delay underline--primary"
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("about_1_3")) + "\n      ")]
            )
          ]),
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("about_2_1")) + "\n      "),
            _c("br"),
            _c("br"),
            _vm._v("\n      " + _vm._s(_vm.$t("about_2_2")) + "\n      "),
            _c("span", { staticClass: "underline" }, [
              _vm._v(_vm._s(_vm.$t("about_2_3")))
            ]),
            _c("br"),
            _c("br"),
            _vm._v("\n      " + _vm._s(_vm.$t("about_2_4")) + "\n      "),
            _c(
              "a",
              {
                staticClass: "underlined primary",
                attrs: {
                  href: "http://www.wygroup.net",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v(_vm._s(_vm.$t("about_2_5")) + " ")]
            ),
            _vm._v("\n      " + _vm._s(_vm.$t("about_2_6")) + "\n    ")
          ])
        ]
      ),
      _c("about-photo-view"),
      _c("about-view", { attrs: { variant: "reverse" } }, [
        _c("span", { attrs: { slot: "title" }, slot: "title" }, [
          _c(
            "div",
            { staticClass: "underline underline--no-delay underline--primary" },
            [_vm._v("\n        " + _vm._s(_vm.$t("about_3_1")) + "\n      ")]
          ),
          _c(
            "div",
            {
              staticClass:
                "on-tablet underline underline--no-delay\n      underline--primary"
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("about_1_4")) + "\n      ")]
          ),
          _c(
            "div",
            {
              staticClass:
                "underline\n        underline--no-delay\n      underline--primary"
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("about_3_2")) + "\n      ")]
          ),
          _vm._v("\n      " + _vm._s(_vm.$t("about_3_3")))
        ]),
        _c("div", { attrs: { slot: "content" }, slot: "content" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("about_4_1")) + "\n      "),
          _c("br"),
          _c("br"),
          _vm._v("\n      " + _vm._s(_vm.$t("about_4_2_1")) + "\n      "),
          _c("br"),
          _c("br"),
          _vm._v("\n      " + _vm._s(_vm.$t("about_4_2_2")) + "\n    ")
        ])
      ]),
      _c("services-full-view"),
      _c("footer-contact-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96c0458e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96c0458e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about.vue
// module id = 505
// module chunks = 14